import PropTypes from 'prop-types';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box, CSSObject } from '@mui/material';

// ----------------------------------------------------------------------

interface Props {
	children?: PropTypes.ReactElementLike;
	style?: CSSObject;
}

export const Page = (props: Props) => {
	const theme = useTheme();
	return (
		<Box
			sx={{
				...props.style,
				height: '100%',
				background: theme.palette.background.paper,
				padding: '24px',
				animation: `Effect .6s`,
				'@keyframes Effect': {
					'0%': {
						opacity: 0,
					},
					'100%': {
						opacity: 1,
					},
				},
			}}
		>
			{props.children}
		</Box>
	);
};
